// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sS46t","type":"styles_type__3hYRg","choices":"styles_choices__Bt0-T"};